import type { MergeMethod } from './types';

/**
 * Calculate the effective merge method based on repository settings and requirements
 * @param allowedMethods - The allowed merge methods
 * @param isLinearHistoryRequired - Whether linear history is required
 * @param preferredMergeMethod - The user's preferred merge method
 * @returns The effective merge method to use
 */
export function getEffectiveMergeMethodFromStatus(
  allowedMethods: Array<'MERGE' | 'SQUASH' | 'REBASE'> | undefined,
  isLinearHistoryRequired: boolean,
  preferredMergeMethod: MergeMethod,
): MergeMethod {
  const allow_merge_commit = allowedMethods?.includes('MERGE') ?? false;
  const allow_squash_merge = allowedMethods?.includes('SQUASH') ?? false;
  const allow_rebase_merge = allowedMethods?.includes('REBASE') ?? false;

  let candidateMethod = preferredMergeMethod;

  if (isLinearHistoryRequired && candidateMethod === 'merge') {
    if (allow_squash_merge) {
      candidateMethod = 'squash';
    } else if (allow_rebase_merge) {
      candidateMethod = 'rebase';
    } else {
      candidateMethod = 'squash';
    }
  }

  const isCandidateAllowed =
    (candidateMethod === 'merge' && allow_merge_commit) ||
    (candidateMethod === 'squash' && allow_squash_merge) ||
    (candidateMethod === 'rebase' && allow_rebase_merge);

  if (isCandidateAllowed) {
    return candidateMethod;
  }

  if (isLinearHistoryRequired) {
    if (allow_squash_merge) {
      return 'squash';
    }
    if (allow_rebase_merge) {
      return 'rebase';
    }
    return 'squash';
  }

  if (allow_squash_merge) {
    return 'squash';
  }
  if (allow_rebase_merge) {
    return 'rebase';
  }
  if (allow_merge_commit) {
    return 'merge';
  }

  return preferredMergeMethod;
}
